import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { ModuleBase } from '@loanbossinc/component-library';
import Divider from '@material-ui/core/Divider';
import { withRouter } from "react-router";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { propertyGetByDeal, propertyGetDeal, propertyGetDealMetrics } from './property.store';
import { PropertyActiveTable } from "./propertyActiveTableLite";
import { PropertySoldTable } from "./propertySoldTable";
import styled from "styled-components";
import {
  SecondaryButton
  , DefaultModuleHeader
  , ButtonSizeOptions
  , DEAL_STATUSES
  , mapMetricFromList
  , DEAL_METRICS
  , ModuleEmptyButton
  , HomeWork
} from '@loanbossinc/component-library';
import { Collapse } from "@material-ui/core";
import featureFlags from "../../constants/featureFlags";

const StyledRow = styled.div`
  && {
    height: 70px;
    font-style: normal;
    padding-right: 24px;
    padding-left: 24px;

    .metric-title {
      font-family: "Work Sans";
      font-size: 12px;
      font-weight: 600;
      text-align: left;
      float: left;
      color: #5F6368;
      line-height: 70px;
    }

    .metric-value {
      font-family: "Space Mono";
      font-size: 20px;
      font-weight: 400;
      text-align: right;
      float:right;
      line-height: 70px;
    }
  }
`;

const StyledTitleWrapper = styled.div`
  && {
    span.sold-properties {
      font-size: 20px;
      color: #5F6368;
      margin-left: 4px;
    }
  }
`;

const ACTIVE_STATE = 'ACTIVE';
const SOLD_STATE = 'SOLD';
const ACTIVE_AND_SOLD_STATE = 'ACTIVE-SOLD';

class PropertyModuleLite extends React.Component {
  state = {
    activeProperties: []
    , soldProperties: []
    , showSummary: true
    , isExpanded: false
    , currentState: null
  }

  componentDidMount() {
    const { dealId } = this.props.match.params;

    this.props.propertyGetDeal({ dealId });

    this.props.propertyGetByDeal({ dealId });
    this.props.propertyGetDealMetrics({ dealId });
  }

  componentDidUpdate(prevProps) {
    const { properties, deal } = this.props;
    if (
      this.hasDeal()
      && !!properties.length
      && (deal.id !== prevProps.deal.id || properties !== prevProps.properties)
    ) {
      this.updateLists();
    }
  }

  toggleIsExpanded = () => this.setState({ ...this.state, isExpanded: !this.state.isExpanded });
  toggleShowSummary = () => this.setState({ ...this.state, showSummary: !this.state.showSummary });
  hasDeal = () => !!this.props.deal && !!this.props.deal.id;

  getSummaryMetrics = () => {
    const { dealMetrics } = this.props;
    const { activeProperties } = this.state;
    if (!activeProperties || !activeProperties.length) {
      return [];
    }
    const useNewMetrics =
      this.props.flags(featureFlags.GLA453_CLIENTS_WHO_USE_NEW_METRICS)?.includes(this.props.authentication.user.contact.companyId) ||
      this.props.flags[featureFlags.GLA453_USE_NEW_METRICS] ||
      (this.props.flags[featureFlags.GLA453_SYSTEM_ADMINISTRATORS_USE_NEW_METRICS] && this.props.authentication.isSystemAdmin);

    return [
      {
        title: "Market Value"
        , metricValue: mapMetricFromList(useNewMetrics ? DEAL_METRICS.MARKET_VALUE_NEW : DEAL_METRICS.MARKET_VALUE, dealMetrics)
        , type: 'CURRENCY'
      }, {
        title: "noi"
        , metricValue: mapMetricFromList(useNewMetrics ? DEAL_METRICS.NOI_ACTUAL_NEW : DEAL_METRICS.NOI_ACTUAL, dealMetrics)
        , type: 'CURRENCY'
      }
    ];
  }

  updateLists = () => {
    const { properties, deal } = this.props;

    // in the case that the deal is sold, then all properties are considered sold.
    if (deal.dealStatusId === DEAL_STATUSES.SOLD) {
      this.setState({ ...this.state, soldProperties: properties, currentState: SOLD_STATE });
    } else {
      const activeProperties = properties.filter(prop => !prop.actualExitDate);
      const soldProperties = properties.filter(prop => !!prop.actualExitDate);

      let currentState = `${activeProperties.length ? ACTIVE_STATE : ''} ${soldProperties.length ? SOLD_STATE : ''}`;
      currentState = currentState.trim();
      currentState = currentState.replace(' ', '-');

      this.setState({
        ...this.state
        , activeProperties
        , soldProperties
        , currentState
        , showSummary: !!activeProperties && !!activeProperties.length
      });
    }
  }

  getHeaderButton = () => {
    const { showSummary, activeProperties } = this.state;
    const isOneProperty = !!activeProperties && activeProperties.length === 1;
    if (!activeProperties || !activeProperties.length) return null;

    const detailButton = isOneProperty ? "Show Details" : "Show Properties";
    const label = showSummary ? detailButton : "Show Summary";

    const onClick = isOneProperty ? () => this.goToProperty(activeProperties[0].id) : this.toggleShowSummary;

    return (
      <SecondaryButton
        label={label}
        size={ButtonSizeOptions.smFluid}
        onClick={onClick}
      />
    );
  }

  getTitleInfo = () => {
    const { activeProperties, soldProperties, currentState } = this.state;

    if (!currentState) return { title: null, subTitle: null };

    const list = currentState === ACTIVE_STATE ? activeProperties : soldProperties;

    if (currentState !== ACTIVE_AND_SOLD_STATE) {
      if (list.length === 1) {
        const prop = list[0];

        return {
          title: prop.address
          , subTitle: `${prop.city}, ${prop.stateRef ? prop.stateRef.value : ''} ${prop.zip || ''}`
        }
      }

      return {
        title: `${list.length} ${list.length > 1 ? 'Properties' : 'Property'}`
        , subTitle: null
      }
    }

    // handles ACTIVE_AND_SOLD_STATE
    const title = (
      <StyledTitleWrapper>
        {!!activeProperties.length && <span className="active-properties">{activeProperties.length} {`${activeProperties.length > 1 ? 'Properties' : 'Property'}`}</span>}
        {!!soldProperties.length && <span className="sold-properties">(and {soldProperties.length} sold)</span>}
      </StyledTitleWrapper>
    )

    return { title };
  }

  goToProperty = (id) => {
    const { dealId } = this.props.match.params;

    const url = `/properties/${id}/${dealId}`;

    this.props.history.push(url);
  }

  renderSoldTable = () => {
    const { history } = this.props;
    const { soldProperties, currentState, isExpanded, showSummary } = this.state;

    const isSummaryAndExpanded = showSummary && isExpanded;
    const isSoldState = currentState && currentState === SOLD_STATE;
    const isActiveAndSoldAndExpanded = currentState === ACTIVE_AND_SOLD_STATE && isExpanded;

    const shouldShow = isSummaryAndExpanded || isSoldState || isActiveAndSoldAndExpanded;
    const properties = isExpanded ? soldProperties : soldProperties.slice(0, 3);

    return (
      <Collapse in={shouldShow}>
        <PropertySoldTable history={history} properties={properties} />
      </Collapse>
    );
  }

  renderActiveTable = () => {
    const { history } = this.props;
    const { activeProperties, currentState, isExpanded, showSummary } = this.state;

    const isActiveState = currentState && currentState !== ACTIVE_STATE && !showSummary;
    const IsActiveActiveAndSold = currentState && ACTIVE_AND_SOLD_STATE && !showSummary;
    const shouldShow = isActiveState || IsActiveActiveAndSold;

    const properties = isExpanded ? activeProperties : activeProperties.slice(0, 3);

    return (
      <Collapse in={shouldShow}>
        <PropertyActiveTable history={history} properties={properties} redirect={this.goToProperty} />
      </Collapse>
    );
  }

  renderSummary = () => {
    const { showSummary } = this.state;
    const dealMetrics = this.getSummaryMetrics();

    if (dealMetrics.length < 1) {
      return null;
    }

    return (
      <Collapse in={showSummary}>
        <StyledRow>
          <div className="metric-title">{dealMetrics[0].title}</div>
          <div className="metric-value" style={{ fontSize: 24 }}>{dealMetrics[0].metricValue}</div>
        </StyledRow>
        <Divider />
        <StyledRow>
          <div className="metric-title">{dealMetrics[1].title}</div>
          <div className="metric-value" style={{ fontSize: 24 }}>{dealMetrics[1].metricValue}</div>
        </StyledRow>
      </Collapse>
    );
  }

  render() {
    const { properties } = this.props;
    if (!properties || !properties.length) return (
      <ModuleEmptyButton
      style={{ marginTop: '2em', width: '648px' }}
        label="Add a property"
        iconName={<HomeWork />}
        onClick={() => this.goToProperty('new')}
      />
    );

    const { title, subTitle } = this.getTitleInfo();

    return (
      <>
        <ModuleBase>
          <DefaultModuleHeader
            headerElement={[<HomeWork />]}
            headerTitle={title}
            subTitle={subTitle}
            button={this.getHeaderButton()}
          />

          {this.renderSummary()}
          {this.renderActiveTable()}
          {this.renderSoldTable()}
        </ModuleBase>
      </>
    );
  }
}

const mapStateToProps = ({ propertyModule, authentication }) => ({
  ...propertyModule
  , authentication
  , ...propertyModule.propertyModuleReducer
});

export default compose(
  withLDConsumer(),
  withRouter
  , connect(mapStateToProps, {
    propertyGetByDeal
    , propertyGetDeal
    , propertyGetDealMetrics
  })
)(PropertyModuleLite);
